<template>
  <div class="user-wrapper">
    <a-dropdown>
      <a class="ant-dropdown-link" href="#">
        <a-avatar size="large" icon="user" v-bind:src="this.$store.state.account.picture"/>
        {{this.$store.state.account.nickName}}&nbsp;&nbsp;
        <a-icon type="down"/>
      </a>
      <a-menu slot="overlay">
        <a-menu-item>
          <a href="javascript:;" @click="logout">
            <a-icon type="logout"/>&nbsp;&nbsp;退出登录
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>
<script>
export default {
  name: "header-div",
  data() {
    return {
      nickName: this.$store.state.account.nickName
    };
  },
  methods: {
    logout() {
      const url = "/api/1.0/logout";
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.$store.commit("setAccount", {});
          this.$store.commit("setRole", null);
          this.$store.commit("setToken",null);
          this.$router.push({
            path: "/login"
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.user-wrapper {
  float: right;
  height: 100%;
  margin-right: 25px;
}
</style>

